import React from 'react';
import { Shield, Award, CheckCircle, Lock, FileCheck, Users } from 'lucide-react';

const badges = [
  {
    icon: Shield,
    title: "OSHA Aligned",
    description: "Content follows OSHA standards"
  },
  {
    icon: Award,
    title: "Industry Recognized",
    description: "Accepted by 500+ companies"
  },
  {
    icon: CheckCircle,
    title: "Expert Reviewed",
    description: "Verified by safety professionals"
  },
  {
    icon: Lock,
    title: "Secure Platform",
    description: "Your data is protected"
  },
  {
    icon: FileCheck,
    title: "Certificate Included",
    description: "Verifiable completion certificate"
  },
  {
    icon: Users,
    title: "8,500+ Trained",
    description: "Join thousands of professionals"
  }
];

const TrustBadges = () => {
  return (
    <section className="py-12 bg-slate-50 border-y border-slate-200">
      <div className="container mx-auto px-6">
        <div className="text-center mb-8">
          <p className="text-slate-500 text-sm font-medium uppercase tracking-wider">Why Trust WSafe AI™</p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {badges.map((badge, index) => (
            <div 
              key={index}
              className="flex flex-col items-center text-center group"
            >
              <div className="w-14 h-14 rounded-xl bg-white border border-slate-200 flex items-center justify-center mb-3 group-hover:border-emerald-300 group-hover:shadow-md transition-all">
                <badge.icon className="w-7 h-7 text-emerald-600" />
              </div>
              <h4 className="font-semibold text-slate-900 text-sm mb-1">{badge.title}</h4>
              <p className="text-xs text-slate-500">{badge.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
